import React from "react";
import { useGetTeamsQuery } from "../../../features/team/teamApi";
import Team from "./Team";

const Teams = () => {
  const { isError, isLoading, data } = useGetTeamsQuery();

  // decide what to render based on the state of the query
  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>Something went wrong</div>;
  }
  if (!isLoading && !isError && data.length > 0) {
    content = data.map((team) => <Team key={team.id} {...team} />);
  }

  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
};

export default Teams;
